<template>
  <div>
    <div class="container" v-if="aboutUs.info">
      <div class="banner">
        <img style="width: 100%; vertical-align: top" src="../../assets/images/aboutUs/banner.jpg"/>
      </div>
      <div class="tab flex">
        <div @click="tabSwitch(item,index)" class="tab-item" :class="activeIndex==index?'tab-item-select':''" v-for="(item,index) in tabList" :key="index">{{item.name}}</div>
      </div>
      <div class="title-box pc_container">
        <div class="title">{{title}}</div>
        <div class="title-border"></div>
      </div>

      <div class="profile_wrap">
        <div class="profile_detail pc_container">
          <div class="profile_tit">{{aboutUs.info.title}}——</div>
          <div class="en_tit">{{aboutUs.info.en}}</div>
          <div class="picInfo">
            <div class="detail_info">{{ aboutUs.info.introduce }}</div>
            <!-- <div class="detail_more">了解更多</div> -->
            <div class="detail_img">
              <img :src="aboutUs.info.imageUrl ? aboutUs.info.imageUrl : imgSrc" alt="" />
            </div>
          </div>
        </div>
      </div>


      <div class="scroll_wrap">
        <div class="scroll_tit">{{ aboutUs.history.info.title }}</div>
        <div class="card_content gktp pc_container">
          <div class="center-box">
            <swiper ref="mySwiper" :options="swiperOption" style="height: 100%">
              <swiper-slide class="box-slide" v-for="(item, index) in aboutUs.history.list" :key="index">
                <div class="card" v-if="index % 2 == 0">
                  <div class="lineItem">
                    <img src="../../assets/images/aboutUs/line.png" alt="" />
                    <div class="lineTime">{{ item.title }}</div>
                    <div class="lineText">{{ item.value }}</div>
                  </div>
                </div>
                <div class="topCard" v-else>
                  <div class="lineItem">
                    <div class="lineText">{{ item.value }}</div>
                    <div class="lineTime">{{ item.title }}</div>
                    <img src="../../assets/images/aboutUs/line.png" alt="" />
                  </div>
                </div>
              </swiper-slide>
            </swiper>
            <div class="line"></div>
          </div>
          <div class="czBtn">
            <div class="swiper-button-prev" slot="button-prev">

            </div>
            <div class="swiper-button-next" slot="button-next">

            </div>
          </div>
        </div>
      </div>

      <div class="enterprise_data">
        <div class="main pc_container">
          <div class="item" v-for="(item,index) in aboutUs.achievement" :key="index">
            <div class="l">
              <img :src="require('../../assets/images/aboutUs/e_icon_0'+(index+1)+'.png')" alt="" />
              <div>{{item.title}}</div>
            </div>
            <div class="r">
              <div class="num">{{item.value}}</div>
              <div class="unit">{{item.unit}}</div>
            </div>
          </div>


          <!-- <div class="item">
            <div class="l">
              <img src="../../assets/images/aboutUs/e_icon_02.png" alt="" />
              <div>公司创收</div>
            </div>
            <div class="r">
              <div class="num">10</div>
              <div class="unit">亿</div>
            </div>
          </div>


          <div class="item">
            <div class="l">
              <img src="../../assets/images/aboutUs/e_icon_03.png" alt="" />
              <div>业绩增长</div>
            </div>
            <div class="r">
              <div class="num">120%</div>
            </div>
          </div> -->
        </div>
      </div>


      <div class="scroll_wrap">
        <div class="scroll_tit">企业发展理念</div>
        <div class="card_content idea pc_container">
          <img src="../../assets/images/aboutUs/img_03.png" alt="" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      activeIndex: 0,
      tabList:[],
      title:'企业介绍',
      imgSrc: require('../../assets/images/aboutUs/img_01.jpg'),
      swiperOption: {
        loop: false,
        slidesPerView: 3,
        spaceBetween: 0,
        direction: 'horizontal',
        grabCursor: true,
        touchStartPreventDefault: false,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        }
      },
      aboutUs:{},
      query:{
        page:1,
        limit:10,
        slug:null,
      },
    };
  },
  created() {

  },
  watch:{
    $route:{
      handler(value){
        if(value.path === '/company/index'){
          this.getType().then(res=>{
            this.tabList = res.data;
            if(value.query.type){
              for(let i=0;i<this.tabList.length;i++){
                if(value.query.type == this.tabList[i].slug){
                  this.activeIndex = i;
                  break
                }
              }
              this.query.slug = value.query.type;
              this.title =  this.tabList[this.activeIndex].name;
             this.getDetail();
            }else {
              this.title =  this.tabList[this.activeIndex].name;
              this.query.slug = this.tabList[this.activeIndex].slug;
              this.getDetail();
            }
          })
        }
      },
      deep:true,
      immediate:true
    },
  },
  methods: {
    // 获取分类
    getType(){
      return this.$request({
        url: `submenu/general`,
        method: 'get',
      })
    },
    // 切换
    tabSwitch(item) {
      this.$router.push({
        path:item.href,
      })
    },
    getDetail(){
      this.$request({
        url: `about`,
        method: 'get',
      }).then(res => {
        this.aboutUs = res.data;
      }).catch(err => {
        console.log(err)
      })
    }
  },
  mounted() {
    
  }
}
</script>

<style scoped lang="scss">
.container{
  width: 100%;
  .banner{
    width: 100%;
    object-fit: cover;
    display: block;
    box-sizing: border-box;
  }
  .tab{
    width: 100%;
    padding: 0 30vw;
    height: 70px;
    background: #ffffff;
    display: flex;
    font-size: 16px;
    color: #333333;
    justify-content: space-between;
    margin-top: -10px;
    .tab-item{
      height: 70px;
      line-height: 70px;
      cursor: pointer;
    }
    .tab-item-select{
     border-bottom: solid 2px #2A59AB;
    }
  }
  .title-box{
    width: 100%;
    margin-top: 30px;
    .title{
      width: 100%;
      text-align: center;
      font-size: 36px;
      color: #333333;
    }
    .title-border{
      width: 115px;
      height: 4px;
      background: #2A59AB;
      margin: auto;
    }
  }

  .profile_wrap {
    width: 100%;
    padding-top: 30px;
    padding-bottom: 30px;
    text-align: center;
    background: #fff;
    min-height: 643px;
    .en_tit {
      font-family: SourceHanSansCN-Normal;
      font-size: 18px;
      color: #DCDCDC;
      width: 75%;
      text-align: left;
    }
    .profile_tit {
      font-family: SourceHanSansCN-Bold;
      font-size: 24px;
      color: #000;
      width: 75%;
      text-align: left;
      @media screen and (max-width: 768px) {
        font-size: 1.2rem;
      }
    }

    .profile_detail {
      display: flex;
      justify-content: flex-start;
      flex-direction: column;
      position: relative;
      padding-left: 735px;
      .detail_info {
        font-family: SourceHanSansCN-Normal;
        font-size: 16px;
        color: #474747;
        line-height:32px;
        margin-top: 20px;
        text-align: left;
        text-indent: 2em;
      }
      .detail_more{
        width: 144px;
        height: 42px;
        background: #2A59AB;
        color: #fff;
        text-align: center;
        line-height: 42px;
        margin-top: 30px;
        cursor: pointer;
      }
      .detail_img {
        position: absolute;
        left: 0;
        top: 0;
        width: 661px;
        height: 643px;
        img {
          width: 100%;
          height: 100%;
        }
      }
    }
  }


  .scroll_wrap {
    width: 100%;
    padding-top: 40px;
    padding-bottom: 71px;
    text-align: center;
    background: #fcfcfc;

    .scroll_tit {
      font-family: SourceHanSansCN-Bold;
      font-size: 36px;
      color: #000;
      position: relative;

      @media screen and (max-width: 768px) {
        font-size: 1.2rem;
      }

      &::after {
        content: '';
        display: block;
        background: #000;
        margin: 0 auto;
        width: 60px;
        height: 5px;
        background: #006DE8;
        margin-top: 13px;
      }
    }

    .gktp {
      height: 690px;
      display: flex;
      flex-direction: column;
      justify-content: flex-end;

      .center-box {
        height: 690px;
        width: 100%;
        position: relative;
        .line{
          height: 5px;
          background: #BFBFBF;
          border-radius: 2px;
          position: absolute;
          top: 50%;
          width: 100%;
        }

        .card {
          .lineItem{
            position: relative;
            top: 250px;
            img{
              width: 85px;
              height: 85px;
            }
            .lineTime{
              font-family: SourceHanSansCN-Bold;
              font-size: 24px;
              color: #333;
              margin-top: 37px;
              &::after{
                content: '';
                display: block;
                width: 36px;
                height: 2px;
                background: #000;
                margin: 0 auto;
                margin-top: 21px;
              }
            }
            .lineText{
              font-family: SourceHanSansCN-Medium;
              font-size: 16px;
              color: #666;
              margin-top: 39px;
              position: relative;
            }
          }
        }

        .topCard{
          .lineItem{
            position: relative;
            top: 80px;
            img{
              width: 85px;
              height: 85px;
            }
            .lineTime{
              font-family: SourceHanSansCN-Bold;
              font-size: 24px;
              color: #333;
              margin-bottom: 37px;
              &::after{
                content: '';
                display: block;
                width: 36px;
                height: 2px;
                background: #000;
                margin: 0 auto;
                margin-bottom: 21px;
              }
            }
            .lineText{
              font-family: SourceHanSansCN-Medium;
              font-size: 16px;
              color: #666;
              margin-bottom: 39px;
              height:54px;
              overflow: hidden;
            }
          }
        }
      }

      .czBtn {
        width: 150px;
        height: 45px;
        margin: 0 auto;
        margin-top: 69px;
        display: flex;
        justify-content: center;
        align-items: center;
        position: relative;

        .swiper-button-next,
        .swiper-button-prev {
          display: flex;
          align-items: center;
          background-color: rgba(0, 0, 0, .6);
          color:#fff;
          width: 44.5px;
          height: 44.5px;
          z-index: 9;
        }
        .swiper-button-next:after, .swiper-button-prev:after {
          font-size: 20px;
        }
        .swiper-button-next:hover, .swiper-button-prev:hover {
          background: #2A59AB;
        }
      }
    }
    .idea{
      margin-top: 30px;
      img{
        width: 100%;
      }
    }
  }

  .enterprise_data{
    background: url('../../assets/images/aboutUs/img_02.jpg') no-repeat;
    width: 100%;
    height: 353px;
    background-size: 100% 100%;
    .main{
      display: flex;
      justify-content: space-between;
      align-items: center;
      height: 100%;
      .item{
        display: flex;
        color: #fff;
        align-items: center;
        .l{
          display: flex;
          flex-direction: column;
          margin-right: 33px;
          div{font-size: 18px;}
          img{ width: 65px; height: 65px; vertical-align: top;}
        }
        .r{
          display: flex;
          flex-direction: row;
          align-items: baseline;
          .num{
            font-size: 48px;
            line-height:69px;
          }
          .unit{
            font-size: 36px;
            line-height: 26px;
          }
        }
      }
    }
  }
}
</style>
